import { useScopeParams } from "@/hooks/useScopeParams";
import { PageTemplate } from "@/components/Templates/PageTemplate";

export default function Labs({
  singleSubjectId,
}: {
  singleSubjectId?: string;
}) {
  const { id } = useScopeParams();
  const wikiLink = singleSubjectId
    ? "/wiki/guides/exploration-singlesubject-labs"
    : "/wiki/guides/exploration-measures-labs";

  return (
    <PageTemplate
      title="Measures: Labs"
      tooltipText="Explore labs data, create data subsets, view visualizations, and download data and visualizations."
      type="labs"
      constants={{
        wikiLink,
        idLink: (subjectId: string) =>
          `/${id}/subjects/overview/${subjectId}/labs`,
      }}
      subjectId={singleSubjectId}
    />
  );
}
